//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'product-card-audio-info-full',
  components: {
    Pro: () => import('@motionelements/core/src/components/product-card/sections/info/items/ProductInfoItemPro.vue'),
    Price: () => import('@motionelements/core/src/components/product/ElementPrice.vue'),
    Duration: () => import('@motionelements/core/src/components/product-card/sections/info/items/ProductInfoItemDuration.vue'),
  },
  props: {
    element: Object,
    showPrice: {
      type: Boolean,
      default: true,
    },
    showCategory: {
      type: Boolean,
      default: false,
    },
    showArtistName: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    // isSubscription() {
    //   return _.get(this.element, 'subscription');
    // },
    isPro() {
      return _.get(this.element, 'usageRights.pro') === true;
    },
    displayCategories() {
      let category;

      if (this.$route.query.genre) {
        category = this.element.categories.find((x) => x.id === this.$route.query.genre);
        if (category) {
          return [category];
        }
      }

      if (this.$route.query.category) {
        category = this.element.categories.find((x) => x.id === this.$route.query.category);
        if (category) {
          return [category];
        }
      }

      category = this.element.categories.find((x) => x.type === 'genre');

      if (category) {
        return [category];
      }

      category = this.element.categories.find((x) => x.type === 'category');

      return category ? [category] : [];
    },
  },
};
